import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

import SkeletonField from './SkeletonField'
import SkeletonTable from './SkeletonTable'

const Heading = ({ width }: { width: number }) => (
    <Skeleton variant="text" width={width} sx={{ fontSize: '1.25rem', mb: 1.5 }} />
)

export default function SkeletonRuleDetails() {
    return (
        <Grid container spacing={2} size={12}>
            <Grid size={12}>
                <Paper sx={{ p: 2 }}>
                    <Stack spacing={1}>
                        <Skeleton variant="text" width={200} sx={{ fontSize: '1.5rem' }} />
                        <Skeleton variant="text" width={90} />
                    </Stack>
                </Paper>
            </Grid>

            <Grid size={12}>
                <Paper sx={{ p: 3 }}>
                    <Grid container spacing={4} rowSpacing={4}>
                        <Grid size={12}>
                            <Heading width={90} />
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12, sm: 3 }}>
                                    <SkeletonField />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 3 }}>
                                    <SkeletonField />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <SkeletonField />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Heading width={70} />
                            <SkeletonTable rows={1} columns={3} showToolbar={false} />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Heading width={80} />
                            <SkeletonTable rows={1} columns={2} showToolbar={false} />
                        </Grid>

                        <Grid size={12}>
                            <Heading width={90} />
                            <SkeletonTable rows={2} columns={7} showToolbar={false} />
                        </Grid>

                        <Grid size={12}>
                            <Heading width={140} />
                            <SkeletonTable rows={1} columns={4} showToolbar={false} />
                        </Grid>
                    </Grid>

                    <Stack direction="row" spacing={2} sx={{ justifyContent: 'center', pt: 4 }}>
                        <Skeleton variant="rounded" width={280} height={40} />
                        <Skeleton variant="rounded" width={280} height={40} />
                    </Stack>
                </Paper>
            </Grid>
        </Grid>
    )
}
